module.exports = __webpack_public_path__ + "static/media/ibas.8610d2f9.svg";